import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import { VideoService } from '../../services/video.service';


@Component({
  selector: 'app-video-details',
  templateUrl: './video-details.component.html',
  styleUrls: ['./video-details.component.scss']
})
export class VideoDetailsComponent implements OnInit {

  videoId : any ;
  videoItem : any;
  videoList : any;

  constructor(private route: ActivatedRoute,private videoService : VideoService) {
      this.getVideoIdFromUrl();
}


    getVideoIdFromUrl(){
    this.route.params.subscribe( params => {
      console.log(params);
      this.videoId = params.video_id;
      this.getVideoDetailsFromServer();
    });

  }


  getVideoDetailsFromServer(){
    var body = {"video_id":""+this.videoId};

    this.videoService.getVideoDetails(body).subscribe((resp : any) => {
      this.onVideoDetailsSuccess(resp);
      }, (err) => {
    // Unable to log in
          this.onVideoDetailsFetchError(err);    
    });

  }


  onVideoDetailsSuccess(resp){
      this.videoItem = resp;
      this.getAllVideosInThisSeries();
  }

  onVideoDetailsFetchError(err){

  }



  getAllVideosInThisSeries(){
    let body = {"subject" : ""+this.videoItem.tags.subject};
    this.videoService.getAllVideosListInCategory(body).subscribe((resp : any) => {
      this.onVideoListSucess(resp);
      }, (err) => {
    // Unable to log in
          this.onVideosListError(err);    
    });
  }



  onVideoListSucess(resp : any){
    this.videoList = resp;
  }

  onVideosListError(err : any){

  }




  ngOnInit() {
  }

}
